var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"shortkey",rawName:"v-shortkey",value:({
        search:['ctrl', 'f'],
        edit:['ctrl', 'e'],
        cancel:['ctrl','b'],
        save:['ctrl','s'],
        add:['ctrl','a'],
        delete:['ctrl','d'],
        shiftDown:['shift','arrowdown'],
        shiftUp:['shift','arrowup']
    }),expression:"{\n        search:['ctrl', 'f'],\n        edit:['ctrl', 'e'],\n        cancel:['ctrl','b'],\n        save:['ctrl','s'],\n        add:['ctrl','a'],\n        delete:['ctrl','d'],\n        shiftDown:['shift','arrowdown'],\n        shiftUp:['shift','arrowup']\n    }"}],on:{"shortkey":_vm._hkActions}})}
var staticRenderFns = []

export { render, staticRenderFns }